import { apiSlice, apiSliceWithoutAuth } from "../apiSlice";

export const chartApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChartData: builder.query({
      query: ({ team_ids, department_ids, org_id }) =>
        // `/org/chart/employee-level-new/?team_ids=${team_ids}&department_ids=${department_ids}&org_id=${org_id}`,
        `/org/chart/employee-level/?team_ids=${team_ids}&department_ids=${department_ids}&org_id=${org_id}`,
      keepUnusedDataFor: 0,
    }),
    shareChartData: builder.mutation({
      query: (shareData) => ({
        url: "/org/org_chart/share/",
        method: "POST",
        body: shareData,
      }),
    }),
  }),
});

export const chartApiSliceWithoutAuth = apiSliceWithoutAuth.injectEndpoints({
  endpoints: (builder) => ({
    getSharedChartData: builder.query({
      query: ({ share_id }) =>
        `/org/org_chart/shared/${share_id}`,
    }),
    getSharedChartPdfData: builder.query({
      query: ({ hash_id, email }) => ({
        url: `/org/org_chart_pdf/${hash_id}/?recipient_email=${email}`,
        method: "GET",
        responseHandler: async (response) => {
          const data = await response.json(); // Parsing the JSON response
          return data;
        },
      }),
    }),
  })
})

export const { useGetChartDataQuery, useShareChartDataMutation } = chartApiSlice;
export const { useGetSharedChartDataQuery, useLazyGetSharedChartPdfDataQuery } = chartApiSliceWithoutAuth
